<template>
  <div class="lab-staff">
    <StaffContents
        :profileImg="require('../../assets/img/lab/staff/08/profile.png')"
        :profileImgSp="require('../../assets/img/lab/staff/08/profile_sp.png')"
        profileAlt="08 KENTA USHIRO"
        answer01="大学では化学を専攻していましたが大学院で取り組んでいたのは物理学寄りの、レーザー光を使って微小な物体を動かす光ピンセット技術の研究です。オングストロームサイズの原子やマイクロサイズの細胞などとは異なり、原理的に難しいとされたナノサイズ物体の操作を実現するため研究に取り組んでいました。大学院時代に知った研究の魅力は、私のような若手でも自分の研究成果次第で世界の最先端につながれるということでした。自分の提案が世の中に役立つ、社会を大きく動かす価値になる可能性が、今の仕事のモチベーションになっています。"
        :answer02="'学生の頃から、日本が直面する大きな課題に研究開発で挑みたいと考えていました。幅広い技術リソースを持っているクレハであれば、あらゆる分野の課題に挑戦できる。さらにクレハにはゼロイチ人財枠(※)があります。ゼロからの事業創出に若手からチャレンジできる制度で、クレハのような規模の企業がこうした挑戦的な採用を推進していることに強く惹かれました。高齢者医療に関するメーカーなども検討していましたが、ゼロイチ人財枠の採用でクレハ入社を決めました。実際に様々な面からサポートを受けながら、提案した製品の事業化に向けて邁進しています。\n※博士採用のみ対象'"
        answer03="入社2年目に半導体関連の新規事業プロジェクトを提案し、概念実証したパワー半導体関連のテーマに取り組んでいます。仕事内容は多岐に渡り、実験だけでなく、上司に「来週アメリカに行ってヒアリングしてみよう」と言われ急遽海外へ出張したり、事業化に向けて複数の特許申請なども行いました。現在は新製品をクレハの事業として収益化していくために、本社でマーケティングに注力している段階です。事業を起こすというのは本当にタフな仕事ですが、毎日やりがいを感じながら働けています。"
        answer04="特に半導体産業に向けて、クレハにしか作れないものを開発し、社会に貢献することが目標です。例えば、クレハ独自のPGA樹脂を応用すれば、次世代省エネデバイスの低コスト化に寄与できると考えています。高性能な省エネデバイスが安価になればそれだけ利用が広がり、持続可能な社会に大きく貢献できます。半導体産業は他と比べて市場規模が大きいので、クレハの独自性で新たな道を拓いていくことで、もっと大きなビジネスにつなげていけると考えています。"
        answer05="挑戦を制度面でもカルチャー面でも後押ししてくれるところです。クレハも会社である以上、ビジネスとして成り立つ事業をつくることが求められます。そのために語学力、ITスキルやビジネス教養が必要になってきますが、学びのための制度が充実しているので、必要な知識、スキルをどんどん吸収し、成長していくことができます。また、充実した福利厚生のおかげで住環境も整えられ、仕事に全力投球できています。カルチャー面では上司や周りの同僚がみな相談しやすく、やりたいことを「いいね、やろうよ！」と後押ししてくれる土壌があるので、失敗を恐れずに日々挑戦できています。"
        answer06="妻とお出かけをしています。美味しいご飯を食べに行ったり、服を買いに行ったり映画を見たりと、妻と一緒に休日を楽しんでいます！私は家での時間も好きなタイプなので、外へお昼ご飯を食べに行った日は残りの半日を家で過ごすなど、バランスを取りながらリフレッシュしています。いわきにいたときは近場だけでなく仙台や会津、福岡などよく遠出をしていました。最近は妻と海外旅行も計画中で、「シンガポールに行きたいね」と話しているところです！"
        :imageCut01="require('../../assets/img/lab/staff/08/image01.jpg')"
        :imageCut02="require('../../assets/img/lab/staff/08/image02.jpg')"
        :imageCut01Sp="require('../../assets/img/lab/staff/08/image01_sp.jpg')"
        :imageCut02Sp="require('../../assets/img/lab/staff/08/image02_sp.jpg')"
        :schedule="require('../../assets/img/lab/staff/08/schedule.png')"
        :scheduleSp="require('../../assets/img/lab/staff/08/schedule_sp.png')"
    />
  </div>
</template>

<script>
import StaffContents from "@/components/lab/StaffContents.vue";
export default {
  name: 'staff_member',
  components: {
    StaffContents,
  },
  methods: {
    startIntersectionObserver: function(targets) {
      this.intersectionObserver = new IntersectionObserver(changes => {
        changes.forEach(change => {
          if(change.isIntersecting) {
            change.target.classList.add('is-show');
          }
        });
      },{
        rootMargin: "0px",
        // threshold: [1.0],
      });
      targets.forEach(target => {
        this.intersectionObserver.observe(target);
      });
    },
  },
  mounted() {
    const targets = Array.from(document.querySelectorAll('.faq'));
    this.startIntersectionObserver(targets);
  }
}
</script>
